import type { IconProps } from "../types";

export const Workflow = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <rect width="8" height="8" x="3" y="3" />
    <path d="M7 11v6h6" />
    <rect width="8" height="8" x="13" y="13" />
  </svg>
);
